import { createUseStyles } from 'react-jss'
import { titleFont, textSize } from 'styles/helpers'

export default createUseStyles(theme => ({
  confirmation: {
    position: 'relative',
    marginBottom: 24,
  },
  confirmationTitle: {
    marginBottom: 16,
    ...titleFont(),
    ...textSize(16, 19),
  },
  confirmationText: {
    position: 'relative',
    ...textSize(14, 16),
    paddingLeft: 44,

    '&:before': {
      content: "''",
      display: 'block',
      position: 'absolute',
      left: 0,
      right: 0,
      width: 30,
      height: 30,
      backgroundImage: `url(/images/check-circle.svg)`,
      backgroundSize: '100%',
    }
  }
}))
